export const routes = {
    ROOT: "/",
    SERVICES: "/services",
    REINTEGRATION: "/reintegration",
    ABOUT: "/about",
    CONTACT: "/contact"
};
